'use strict';

import { initVineStockOrderForm } from './vine-stock-order-form/index.js';

/**
 * Initialise les comportements JavaScript des formulaires du site.
 */
export function initForms() {
    initVineStockOrderForm();
}
